import { InnerButton } from '@/modules/InnerButton';
import React from 'react';
import { faAngleLeft, faAngleRight } from '@fortawesome/pro-regular-svg-icons';

interface NavigationButtonProps {
  direction: 'prev' | 'next';
  onClick: () => void;
  disabled?: boolean;
}

export const NavigationButton: React.FC<NavigationButtonProps> = ({
  direction,
  onClick,
  disabled = false,
}) => {
  return (
    <>
      <InnerButton
        theme="solid"
        size="xxs"
        color="secondary"
        pill="xs"
        onClick={onClick}
        className="ui-z-10"
        disabled={disabled}
        icon={direction === 'prev' ? faAngleLeft : faAngleRight}
      />
    </>
  );
};
